module.exports = __webpack_public_path__ + "assets/img/87598786f71b2623d2dfe9fa263670b2.png";